export default __webpack_public_path__ + "static/media/32-icon-caption.0badcddf.svg";